import React, { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminDeleteUserModal({ user, open, onClose, onDeleted }) {
  const [confirmEmail, setConfirmEmail] = useState("");
  const [deleting, setDeleting] = useState(false);

  if (!open || !user) {
    return null;
  }

  const emailMatches = confirmEmail.trim().toLowerCase() === user.email.trim().toLowerCase();

  const handleDelete = async () => {
    if (!emailMatches) {
      return;
    }

    setDeleting(true);
    try {
      const token = Cookies.get("token");
      await axios.delete(`${BACKEND_URL}/api/admin/users/${user.id}`, {
        headers: { Authorization: `Bearer ${token}` },
        data: { confirm_email: confirmEmail.trim() },
      });
      toast.success("User and all related data deleted");
      onDeleted?.();
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(
        detail || "Failed to delete user",
      );
    } finally {
      setDeleting(false);
    }
  };

  const handleClose = () => {
    if (deleting) {
      return;
    }
    setConfirmEmail("");
    onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="admin-delete-user-title"
    >
      <div className="w-full max-w-md rounded-xl border border-red-500/30 bg-[#0F1115] p-6 shadow-xl">
        <h2 id="admin-delete-user-title" className="font-heading text-lg font-semibold text-red-400">
          Delete user and all data
        </h2>
        <p className="mt-3 text-sm text-[#9CA3AF]">
          This permanently deletes <strong className="text-white">{user.email}</strong> and all
          related chats, settings, integrations, billing records in the app, and usage data.
          Payment transaction history is anonymized for audit. This cannot be undone.
        </p>
        <label className="mt-4 block text-sm text-[#9CA3AF]" htmlFor="admin-delete-confirm-email">
          Type the user email to confirm
        </label>
        <input
          id="admin-delete-confirm-email"
          type="email"
          value={confirmEmail}
          onChange={(e) => setConfirmEmail(e.target.value)}
          className="mt-2 w-full rounded-lg border border-white/10 bg-black/40 px-3 py-2 text-sm text-white"
          placeholder={user.email}
          autoComplete="off"
          data-testid="admin-delete-confirm-email"
        />
        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={handleClose}
            disabled={deleting}
            className="px-4 py-2 rounded-lg border border-white/10 text-sm text-[#9CA3AF] hover:bg-white/5 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleDelete}
            disabled={!emailMatches || deleting}
            data-testid="admin-delete-user-submit"
            className="px-4 py-2 rounded-lg bg-red-600 text-sm font-medium text-white hover:bg-red-500 disabled:opacity-50"
          >
            {deleting ? "Deleting…" : "Delete permanently"}
          </button>
        </div>
      </div>
    </div>
  );
}
